export default "__VITE_ASSET__phc5Sono__"